import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "120px",
      size: "mini"
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "查询权限人员",
      prop: "QueryStaffs"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    on: {
      change: function change(v) {
        return _vm.selectedChange(v, "QueryStaffs");
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var data = _ref.data;
        return [_c("el-option", {
          attrs: {
            label: "*所有",
            value: "*"
          }
        }), _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              disabled: _vm.form.QueryStaffs.indexOf("*") !== -1,
              label: item.name,
              value: item.id
            }
          });
        })];
      }
    }]),
    model: {
      value: _vm.form.QueryStaffs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "QueryStaffs", $$v);
      },
      expression: "form.QueryStaffs"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "维护权限人员",
      prop: "MangerStaffs"
    }
  }, [_c("cpsc-select", {
    attrs: {
      multiple: "",
      filterable: "",
      "collapse-tags": "",
      data: _vm.staffsList,
      "is-filter": true,
      "filter-name": "name",
      "filter-code": "id",
      placeholder: "请选择"
    },
    on: {
      change: function change(v) {
        return _vm.selectedChange(v, "MangerStaffs");
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var data = _ref2.data;
        return [_c("el-option", {
          attrs: {
            label: "*所有",
            value: "*"
          }
        }), _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: {
              disabled: _vm.form.MangerStaffs.indexOf("*") !== -1,
              label: item.name,
              value: item.id
            }
          });
        })];
      }
    }]),
    model: {
      value: _vm.form.MangerStaffs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "MangerStaffs", $$v);
      },
      expression: "form.MangerStaffs"
    }
  })], 1), _c("el-form-item", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };